// List of common profanities and offensive terms
// This is a basic list - you can expand it as needed
const profanityList = [
  'damn', 'hell', 'crap', 'ass', 'piss', 'fuck', 'shit', 'bastard',
  'bitch', 'asshole', 'dick', 'cock', 'pussy', 'whore', 'slut',
  'kys', 'kill yourself', 'stfu', 'shut the fuck up'
];

// Aggressive/harassment patterns
const aggressionPatterns = [
  /[A-Z]{5,}.{0,10}[!?]{2,}/, // Lots of caps followed by multiple punctuation
  /[A-Z\s]{10,}[!?]{2,}/, // Predominantly caps + multiple punctuation
  /([!?]){3,}/, // Multiple punctuation (!!!  ???)
  /(fuck|shit|damn|hell|ass|dick|cock|pussy).*(you|ur|everyone|all of you|this city|herndon)/i, // Direct profanity at people
  /screw (this|you|herndon|the city|this town|these people|them)/i, // Hostile language
  /hate.*(herndon|residents|people|this town|this city)/i, // Hate directed at town/citizens
];

/**
 * Check if a comment contains profanity or aggressive language
 * Returns an object with { isFlagged: boolean, reason: string }
 */
export function checkCommentSafety(commentText) {
  if (!commentText || typeof commentText !== 'string') {
    return { isFlagged: false, reason: null };
  }

  // Quick test - check for 3+ exclamation or question marks
  if (/[!?]{3,}/.test(commentText)) {
    return { isFlagged: true, reason: 'aggression' };
  }

  const lowerText = commentText.toLowerCase();

  // Check for profanities
  for (const word of profanityList) {
    const pattern = new RegExp(`\\b${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b|${word.replace(/(.)/g, '$1[^a-z]*')}`, 'gi');
    if (pattern.test(commentText)) {
      return { isFlagged: true, reason: 'profanity' };
    }
  }

  // Check for aggressive/harassment patterns
  for (let i = 0; i < aggressionPatterns.length; i++) {
    const pattern = aggressionPatterns[i];
    if (pattern.test(commentText)) {
      return { isFlagged: true, reason: 'aggression' };
    }
  }

  return { isFlagged: false, reason: null };
}
